import React from 'react';
import { useTranslation } from 'react-i18next';
import Status, { Wrapper, Source } from './ReservationStatus.style';

const ReservationStatus = ({ className, status, source }) => {
  const { t } = useTranslation();

  const getSourceLabel = source => {
    const labels = {
      BOATER: t('RESERVATION_SOURCE_CRTEATED_BY_YOU'),
      MARINA: t('RESERVATION_SOURCE_CRTEATED_BY_MARINA')
    };
    return labels[source];
  };

  if (source) {
    return (
      <Wrapper>
        <Status className={className} status={status}>
          {t(status)}
        </Status>
        <Source>{getSourceLabel(source)}</Source>
      </Wrapper>
    );
  } else {
    return (
      <Status className={className} status={status}>
        {t(status)}
      </Status>
    );
  }
};

export default ReservationStatus;
